import { SITE_ROUTES } from "@/config/siteRoutes";
import { CmsManagedPage } from "@/pages/EditorialPages/CmsManagedPage";
import type { CmsContentPageData } from "@/pages/shared/cmsContent";

const fallback: CmsContentPageData = {
  id: 7,
  slug: "our-values",
  title: "Our Values",
  intro:
    "The values that connect experience, aesthetics and execution, and keep the VenueX standard composed instead of generic.",
  seoTitle: "Our Values",
  searchDescription:
    "VenueX values page around excellence, discipline, tailored execution, professionalism and quiet guidance.",
  url: SITE_ROUTES.values,
  bodyHtml: "",
  sections: [],
  paragraphs: [
    {
      html: "<p>We do not measure a project only by how beautiful it looks. We measure it by how responsibly it is shaped, how clearly it is carried and how strongly it remains in memory.</p>",
      text: "We do not measure a project only by how beautiful it looks. We measure it by how responsibly it is shaped, how clearly it is carried and how strongly it remains in memory.",
    },
    {
      html: "<p>Excellence here means practical depth, tailored thinking and professional integrity strong enough to support demanding productions without visible friction.</p>",
      text: "Excellence here means practical depth, tailored thinking and professional integrity strong enough to support demanding productions without visible friction.",
    },
    {
      html: "<p>We prefer discreet control over visible chaos. The best coordination is often felt as ease rather than announced as effort.</p>",
      text: "We prefer discreet control over visible chaos. The best coordination is often felt as ease rather than announced as effort.",
    },
    {
      html: "<p>The client should sense these values in the timing, the tone of voice, the design decisions and the final delivery before we ever need to explain them.</p>",
      text: "The client should sense these values in the timing, the tone of voice, the design decisions and the final delivery before we ever need to explain them.",
    },
  ],
};

export function OurValuesPage() {
  return (
    <CmsManagedPage
      slug="our-values"
      currentPath={SITE_ROUTES.values}
      eyebrow="What holds the standard"
      visualImage="/static/venuex/live/venuex-onsite.jpg"
      visualAlt="VenueX values translated into calm execution"
      leadTitle="The behavior behind the promise"
      leadCopy="This route should make the standard feel credible by connecting taste, discipline, care and delivery into one readable structure."
      routeLinks={[
        { href: SITE_ROUTES.identity, label: "Return to the identity route", meta: "Brand layer" },
        { href: SITE_ROUTES.portfolio, label: "See the values inside real work", meta: "Selected cases" },
        { href: SITE_ROUTES.contact, label: "Open a project inquiry", meta: "Contact" },
      ]}
      primaryCtaLabel="Contact VenueX"
      primaryCtaHref={SITE_ROUTES.contact}
      secondaryCtaLabel="View portfolio"
      secondaryCtaHref={SITE_ROUTES.portfolio}
      fallback={fallback}
    />
  );
}
